import { render } from "./StockAlerts.vue?vue&type=template&id=20df1678&scoped=true&ts=true"
import script from "./StockAlerts.vue?vue&type=script&lang=ts"
export * from "./StockAlerts.vue?vue&type=script&lang=ts"

import "./StockAlerts.vue?vue&type=style&index=0&id=20df1678&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20df1678"]])

export default __exports__